import { fromJS } from 'immutable';
import * as actionTypes from './actionTypes'

const initialState = fromJS({
  docCentreData: {
    isLoading: true,
    data: {},
    arrayData: [],
    length: 0
  },
  filteredData: [],
  showMore: false,
  accordionName: '',
  viewButton: true,
  gridAccordionCheckbox: {},
  exitClick: '',
  OkClick: '',
  downloadAll: false,
  checkboxArray: {},
  selectDropdown: '',
  timeFrameDates: '',
  dummyUpdate: { dummy: '' },
  dates: {
    start: "",
    end: ""
  },
})

export const documentCentre = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.docCentreDataSuccessType:
      let objData = action.payload.response;
      let length = 0;
      Object.keys(objData).map((key) => {
        length += objData[key].length;
        return true;
      });
      const result = Object.keys(objData).map((key) => {
        return [(key), objData[key]];
      });
      let files = result.map((data) => {
        let emptyData = data[1].forEach(() => { return { "selected": false } });
        return emptyData;
      });
      return state.setIn(["docCentreData", "data"], objData)
        .setIn(['docCentreData', 'arrayData'], result)
        .setIn(["docCentreData", "length"], length)
        .setIn(["checkboxArray"], { "selectedFiles": files, "selected": [] })
        .setIn(['filteredData'], result);
    case actionTypes.checkboxSelectType:
      return state.setIn(["checkboxArray"], { "selected": action.payload.selected, "selectedFiles": action.payload.selectedFiles })
        .setIn(["dummyUpdate", "dummy"], false);
    case actionTypes.dropdownSelectType:
      return state.setIn(["selectDropdown"], action.payload);
    case actionTypes.fetchStartDateType:
      return state.setIn(['dates', 'start'], action.payload);
    case actionTypes.fetchEndDateType:
      return state.setIn(['dates', 'end'], action.payload);
    case actionTypes.viewButtonClickType:
      return state.setIn(['viewButton'], action.payload);
    case actionTypes.downloadClickType:
      return state.setIn(['downloadAll'], action.payload);
    case actionTypes.exitClickType:
      let downloadAllval = state.getIn(['downloadAll'])
      return state.setIn(['downloadAll'], !downloadAllval);
    case actionTypes.okClickType:
      return state.setIn(['OkClick'], action.payload);
    case actionTypes.showMoreClickType:
      let showMoreVal = state.getIn(['showMore'])
      return state.setIn([`showMore${action.payload}`], !(showMoreVal + action.payload))
        .setIn(['accordionName'], action.payload)
    case actionTypes.filterGridDataType:
      return state.setIn(['filteredData'], action.payload);
    case actionTypes.switchButtonType:
      let file = [];
      let docData = state.getIn(['docCentreData', 'arrayData']);
      docData.map((data) => {
        let emptyData = [];
        data[1].map(() => { emptyData.push({ "selected": false }) });
        file.push(emptyData);
      });
      return state.setIn(['viewButton'], action.payload)
        .setIn(["checkboxArray"], { "selectedFiles": file, "selected": [] });
    case actionTypes.accordionCheckboxSelectType:
      return state.setIn(["gridAccordionCheckbox", `${action.payload.name}`], action.payload);
    case actionTypes.multiSelectOptionType:
      let selectedVal = []
      if (action.payload.length === 1 && action.payload.value[0] === "All") {
        selectedVal = action.payload.value;
      }
      else if (action.payload.value.length > 1 && action.payload.value[0] === "All") {
        action.payload.value.splice(action.payload.value.indexOf('All'), 1);
        selectedVal = action.payload.value;
      }
      else if (action.payload.value.length > 1 && action.payload.value[action.payload.value.length - 1] === "All") {
        selectedVal = ['All']
      }
      else if (action.payload.length === 1 && action.payload.value[0] === "Custom Dates") {
        selectedVal = action.payload.value;
      }
      else if (action.payload.value.length > 1 && action.payload.value[0] === "Custom Dates") {
        action.payload.value.splice(action.payload.value.indexOf('Custom Dates'), 1);
        selectedVal = action.payload.value;
      }
      else if (action.payload.value.length > 1 && action.payload.value[action.payload.value.length - 1] === "Custom Dates") {
        selectedVal = ["Custom Dates"]
      }
      else {
        selectedVal = action.payload.value;
      }
      return state.setIn(["multiSelectValue"], selectedVal);
    case actionTypes.timeFrameChangeType:
      return state.setIn(["timeFrameDates"], action.payload);
    default:
      return state;
  }
}

export default documentCentre;
